exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trial .el-dialog__body{padding:30px 20px !important}\n", ""]);

// exports
